"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
var styles_1 = require("@material-ui/core/styles");
var props_1 = require("../../../context/props");
var columns_1 = require("../../../context/columns");
var index_1 = require("../../../../index");
var SortableList_1 = __importDefault(require("./SortableList"));
var Item_1 = __importDefault(require("./Item"));
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    modalContentRoot: {
        padding: '0 !important',
    },
}); });
var mappingColumnsSettings = function (columns) { return columns
    .map(function (_a) {
    var id = _a.id, visible = _a.visible;
    return ({ key: id, checked: visible });
}); };
var ColumnsSettingModal = function (props) {
    var onClose = props.onClose;
    var onSaveColumnsSettings = (0, props_1.usePropsContext)().onSaveColumnsSettings;
    var _a = (0, columns_1.useColumnsContext)(), columnsState = _a.columnsState, setColumnsState = _a.setColumnsState, translate = _a.translate;
    var classes = useStyles();
    var _b = (0, react_1.useState)(function () { return columnsState; }), columns = _b[0], setColumns = _b[1];
    var _c = (0, react_1.useState)(false), hasChanges = _c[0], setHasChanges = _c[1];
    var isAllColumnsVisible = (0, react_1.useMemo)(function () { return columns.reduce(function (acc, item) { return (!item.visible && !item.isStatic ? false : acc); }, true); }, [columns]);
    var isSomeColumnVisible = (0, react_1.useMemo)(function () { return !!columns.find(function (item) { return item.visible === true; }); }, [columns]);
    var onSortColumns = (0, react_1.useCallback)(function (_a) {
        var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
        setColumns(function (items) { return __spreadArray([], (0, react_sortable_hoc_1.arrayMove)(items, oldIndex, newIndex), true); });
        setHasChanges(function () { return true; });
    }, [setColumns, setHasChanges]);
    var onChangeColumns = (0, react_1.useCallback)(function (_a) {
        var checked = _a.target.checked;
        setColumns(function (items) { return items.map(function (item) { return (__assign(__assign({}, item), (!item.isStatic && { visible: checked }))); }); });
        setHasChanges(function () { return true; });
    }, [setHasChanges, setColumns]);
    var onChangeColumn = (0, react_1.useCallback)(function (_a) {
        var _b = _a.target, checked = _b.checked, value = _b.value;
        setColumns(function (items) { return items.map(function (item) { return (item.id === value ? __assign(__assign({}, item), { visible: checked }) : item); }); });
        setHasChanges(function () { return true; });
    }, [setHasChanges, setColumns]);
    var onSave = (0, react_1.useCallback)(function () {
        var columnsSetting = mappingColumnsSettings(columns);
        onSaveColumnsSettings(columnsSetting);
        setColumnsState(columns);
        onClose();
    }, [columns, onClose, onSaveColumnsSettings, setColumnsState]);
    return (react_1.default.createElement(index_1.ModalDialog, { open: true, onClose: onClose, onOk: onSave, title: translate('dataGrid.columnSettings', 'Column settings'), labelOk: translate('save', 'Save'), labelCancel: translate('cancel', 'Cancel'), fullWidth: true, maxWidth: "xs", isValid: hasChanges && isSomeColumnVisible, classes: {
            content: {
                root: classes.modalContentRoot,
            },
        } },
        react_1.default.createElement(Item_1.default, { id: "all-items", checked: isAllColumnsVisible, isStatic: false, onChangeColumn: onChangeColumns, label: translate('selectAll', 'Select all'), showDragHandle: false }),
        react_1.default.createElement(SortableList_1.default, { onSortEnd: onSortColumns, items: columns, onChangeColumn: onChangeColumn, useDragHandle: true })));
};
exports.default = ColumnsSettingModal;
